import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import LegalPage from './pages/LegalPage';
import './App.css';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/security" element={<LegalPage page="security" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
      </Route>
    </Routes>
  );
}

export default App;
